import { render, staticRenderFns } from "./ServiceGroupEdit.vue?vue&type=template&id=5481e6ba&scoped=true&"
import script from "./ServiceGroupEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServiceGroupEdit.vue?vue&type=style&index=0&id=5481e6ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5481e6ba",
  null
  
)

export default component.exports